export const unservicedSitePictures = [
  {
    display_name: `Site 46`,
    location: require("./unserviced_site_pictures/unserviced_46.webp"),
  },
  {
    display_name: `Site 75`,
    location: require("./unserviced_site_pictures/unserviced_75.webp"),
  },
  {
    display_name: `Site 77`,
    location: require("./unserviced_site_pictures/unserviced_77.webp"),
  },
  {
    display_name: `Site W`,
    location: require("./unserviced_site_pictures/unserviced_w.webp"),
  },
  {
    display_name: `Site X`,
    location: require("./unserviced_site_pictures/unserviced_x.webp"),
  },
];
